import { computed, ref } from '@vue/composition-api'
import { backendFormat, currentMonthPeriod, min } from '@/utils/formatDate'
import Skeleton from '@/components/Skeleton/Skeleton'
import LinkDecorated from '@/components/@ui/LinkDecorated'
import useRequest from '@/compositions/useRequest'
import DriverDialog from '@/components/DriverDialog'
import Calendar from './components/Calendar/Calendar'
import StatisticsByDay from './components/StatisticsByDay/StatisticsByDay'
import DatePicker from '@/components/DatePicker/DatePicker'
import MachineHoursPopup from './components/MachineHoursPopup/MachineHoursPopup.vue'

export default ({
  name: 'Driver',
  components: {
    Skeleton, LinkDecorated, DriverDialog, DatePicker, Calendar, StatisticsByDay, MachineHoursPopup,
  },
  setup(props, context) {
    const { $store } = context.root
    const driver = ref(null)
    const calendar = ref(null)
    const events = []
    const dates = ref([])
    const currentMonthDates = ref()
    const addMachineHoursPopup = ref(false)
    const showAddHoursButton = ref(true)

    currentMonthDates.value = currentMonthPeriod

    const searchPeriod = computed(() => {
      if (dates.value.length) {
        return { start_date: dates.value[0], end_date: dates.value[1] }
      }
      return { start_date: currentMonthDates.value.start, end_date: currentMonthDates.value.end }
    })

    const { loading, makeRequest } = useRequest({
      context,
      request: id => $store.dispatch('drivers/get', { id, data: searchPeriod.value }),
    })

    const init = async () => {
      const { id } = context.root.$route.params
      const data = await makeRequest(id)
      driver.value = data.driver
      calendar.value = data.calendar
    }

    const title = computed(() => {
      const str = 'Табель'
      if (!searchPeriod.value) return str
      return `${str} за период: \n ${searchPeriod.value.start_date} - ${searchPeriod.value.end_date}`
    })

    const generatePdfLink = () => {
      const paramsObj = searchPeriod.value
      let params = ''
      // eslint-disable-next-line guard-for-in,no-restricted-syntax
      for (const [key, value] of Object.entries(paramsObj)) {
        if (params !== '') {
          params += '&'
        }
        params += `${key}=${encodeURIComponent(value)}`
      }
      return `${process.env.VUE_APP_API_URL}/cabinet/driver_reports/${driver?.value?.id}/export/pdf?${params}`
    }

    const showReport = () => {
      window.open(generatePdfLink())
    }

    const update = () => {
      addMachineHoursPopup.value = false
      init()
    }

    const updateDates = () => {
      currentMonthDates.value = dates.value.length ? { start: dates.value[0], end: dates.value[1] || backendFormat(new Date()) } : currentMonthPeriod
      init()
    }

    const updateMonth = (period) => {
      const { start: currentStart, end: currentEnd } = currentMonthDates.value
      const { start, end } = period
      if (currentStart === start && currentEnd === end) return
      currentMonthDates.value = period
      init()
    }

    const popupOpened = ref(false)
    const closePopup = () => {
      popupOpened.value = false
      init()
    }

    init()

    return {
      driver,
      loading,
      title,
      popupOpened,
      events,
      calendar,
      dates,
      currentMonthDates,
      min,
      showAddHoursButton,
      addMachineHoursPopup,
      updateDates,
      updateMonth,
      update,
      closePopup,
      showReport,
    }
  },
})
